import { Navigate, useLocation, useParams } from "react-router-dom";

export const V2_LINK_PREFIX = "/v2";

export const V2LinkRedirect = () => {
  const rest = useParams()["*"] ?? "";
  const { search, hash } = useLocation();
  return <Navigate to={`/${rest}${search}${hash}`} replace />;
};
